import React, { useState } from "react";
import {
  Alert,
  Button,
  Card,
  Form,
  Input,
  Space,
  Spin,
  Typography,
} from "antd";
import { useTrackingCode } from "react-hubspot-tracking-code-hook";

import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../../context/auth.context";
import { FormPage } from "../contents/form-page";
import Cookies from "universal-cookie";

const { Title, Text } = Typography;

export const LoginPage: React.FC = () => {
  const { setPathPageView } = useTrackingCode();
  setPathPageView("/login");

  const { signIn } = useAuth();

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [typeOfError, setTypeOfError] = useState("");
  const cookies = new Cookies();

  const onFinish = async (values: any) => {
    signIn
      .execute(values)
      .then((data) => {
        cookies.set("jwt_authorization", data.jwt);
      })
      .then(() => {
        navigate("/dashboard");
      })
      .catch((error) => {
        console.log(error);
        setTypeOfError("NotAuthorizedException");
      });
  };

  return (
    <FormPage displayFooter={true}>
      <Spin
        size={"large"}
        tip="Loading..."
        className={"full-width"}
        spinning={signIn.loading}
      >
        <Space
          direction={"vertical"}
          size={"small"}
          className={"full-width"}
          style={{ width: "350px" }}
        >
          <Space direction={"vertical"} size={"small"}>
            <Title style={{ marginLeft: "25px" }} level={2}>
              Sign In
            </Title>
            <Text type={"secondary"}></Text>
          </Space>
          <Card>
            {typeOfError === "NotAuthorizedException" && (
              <Alert
                className={"alert"}
                message="Invalid email or password"
                type="error"
                data-cy="login-error-message-text"
              />
            )}
            {/*  {typeOfError === "UserNotConfirmedException" && (
              <Alert
                className={'alert'}
                message="Email not verified, please check your email"
                type="error"
                data-cy="login-error-message-text"
              />
            )}*/}

            <Form
              name="normal_login"
              layout={"vertical"}
              requiredMark={false}
              className="login-form"
              initialValues={{
                email: searchParams.get("email"),
                remember: true,
              }}
              onFinish={onFinish}
            >
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  { required: true, message: "Please input your Email!" },
                ]}
              >
                <Input
                  size="large"
                  type="email"
                  placeholder="Email"
                  data-cy="login-email-input"
                />
              </Form.Item>
              <Form.Item
                name="password"
                label="Password"
                rules={[
                  { required: true, message: "Please input your Password!" },
                  {
                    max: 24,
                    message: "Value should be less than 24 character",
                  },
                ]}
              >
                <Input
                  size="large"
                  type="password"
                  placeholder="Password"
                  data-cy="login-password-input"
                />
              </Form.Item>

              <Space direction={"vertical"} className={"full-width"}>
                <a
                  className="login-form-forgot"
                  href="/forgot-password"
                  data-cy="login-forgot-password-link"
                >
                  Forgot password?
                </a>

                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  className="login-form-button full-width"
                  loading={signIn?.loading}
                  data-cy="login-submit-button"
                >
                  Sign in
                </Button>
              </Space>
            </Form>
          </Card>
        </Space>
      </Spin>
    </FormPage>
  );
};
